import { notify } from 'components/Notifier';
import { downloadFile } from 'services/apiOperations';
import { QueryParams, StockConditionneRepreneurExportParams } from 'types';

export function exportStockConditionneRepreneur(
  sortingCenterId: string,
  exportParams: StockConditionneRepreneurExportParams,
  t: (m: string) => string,
  setModalVisible: (isVisible: boolean) => void,
): void {
  let url = `/sorting_centers/${sortingCenterId}/buyers/stock_conditionne_export`;

  let params: QueryParams = {};

  params['dateOfStockConditionneRepreneur'] = exportParams.dateOfStockConditionneRepreneur.toDateString();

  if (exportParams?.buyerId) {
    params['buyerId'] = exportParams.buyerId;
  }

  if (exportParams?.materialId) {
    params['materialId'] = exportParams.materialId;
  }

  const stringParams = new URLSearchParams(params as Record<string, string>);
  if (!!stringParams.toString()) {
    url += '?' + stringParams.toString();
  }
  setModalVisible(true);
  downloadFile(url)
    .then(() => {
      setModalVisible(false);
      notify({
        message: t('stockConditionneParRepreneurPage.export.success'),
        severity: 'success',
      });
    })
    .catch(() => {
      setModalVisible(false);
    });
}
